import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from '../../../../environments/environment';
import { TranslateService } from "@ngx-translate/core";
import { CustomerService } from "../../services/customer.service";
import { FileUploadConstants } from "../../constants/file-upload.constants";
import { DateConstants } from "../../constants/date.constants";
import { DatePipe } from "@angular/common";
import { ReportService } from "../../services/report.service";
import { CommonService } from "../../../shared/services/common.service";
import { NotificationType } from "../../enums/notification-types.enum";
import { StoreConfig } from "../../../shared/interface/StoreConfig.interface";
import { DistributorIdFormatPipe } from "../../../common/pipes/distributor-id-format.pipe";
import { CurrencyTransformPipe } from "../../../common/pipes/currency-format.pipe";
@Component({
    selector: 'app-pos-summary-reports',
    templateUrl: '../../templates/template1/views/reports/pos-summary-reports.component.html',
    styleUrls: [
        '../../templates/template1/themes/default/less/pos-summary-reports.less'
    ],
    providers: [DistributorIdFormatPipe, CurrencyTransformPipe]
})
export class POSSummaryReportsComponent implements OnInit {
    @Input() fromDate: string;
    @Input() toDate: string;
    @Input() areaCode: string;
    @Input() posLocationId: number;
    @Input() paymentMethods = [];
    @Input() storeInfo: StoreConfig;
    @Input() notesRequired: boolean;
    @Output() isLoadedData = new EventEmitter<boolean>();
    @Output() addFavoriteEvent = new EventEmitter<boolean>();
    pageSizes = [50, 100, 150, 200];
    pageNumber: number = 1;
    pageSize: number = 50;
    pageCount: number = 0;
    currentDate = new Date();
    excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
    printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
    reportsSummary = null;
    allReportsSummary = null;
    isResponseError = false;
    isLoading = false;
    isAllReportsSummaryLoading = false;
    colGroupWidth: string;
    headerLength: number;

    constructor(
        private _translateService: TranslateService,
        private _customerservice: CustomerService,
        private _datePipe: DatePipe,
        private _reportService: ReportService,
        private _commonService: CommonService,
        private distributorFormatPipe: DistributorIdFormatPipe,
        private _currencyPipe: CurrencyTransformPipe
    ) { }

    ngOnInit(): void {
        // this.getPOSOrderSummaryReport();
        // this.setColGroupWidth(); 
        this.exportFile('csv');
    }

    /**
     * To Set the col group width for table
     */
    setColGroupWidth(): void {
        this.colGroupWidth = this.paymentMethods.length ? (100 / (this.paymentMethods.length + 6)) + '%' : (100 / 6) + '%';
        this.headerLength = this.paymentMethods.length ? (this.paymentMethods.length + 6) : 6;
    }

    /**
     * To get POS order summary report
     * @returns void
     */
    getPOSOrderSummaryReport(): void {
        this.isLoading = true;
        this._reportService.getPOSOrderSummaryReport(this.posLocationId, this.fromDate, this.toDate, this.pageNumber, this.pageSize, false, this.notesRequired).subscribe(response => {
            if (response) {
                this.reportsSummary = response;
                this.isLoading = false;
                this.isResponseError = false;
                this.pageCount = response.posOrderCount;
                this.isLoadedData.emit(true);
               
            } else {
                this.setDefaultValues();
            }
        }, (error) => {
            const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
            this.setDefaultValues();
        });
    }

    /**
     * To Set Default Values
     */
    setDefaultValues(): void {
        this.reportsSummary = null;
        this.isLoading = false;
        this.isResponseError = true;
        this.pageCount = 0;
        this.isLoadedData.emit(true);
    }

    /**
     * To load product sales report
     * @returns void
     */
    loadPOSSummaryReports(): void {
        this.getPOSOrderSummaryReport();
    }

    /**
    * To change page size
    * @param  {number} pageSize
    * @returns void
    */
    pageSizeChange(pageSize: number): void {
        if (pageSize) {
            this.pageNumber = 1;
            this.pageSize = pageSize;
            this.getPOSOrderSummaryReport();
        }
    }

    /**
     * To change page number
     * @param  {number} pageNumber
     */
    pageChange(pageNumber: number) {
        this.pageNumber = pageNumber;
        this.getPOSOrderSummaryReport();
    }

    /**
     * To emit add favorite event to parent component
     * @returns void
     */
    addToFavorite(): void {
        this.addFavoriteEvent.emit(true);
    }

    /**
     * To Export The file
     */
    exportFile(type): void {
        // if (this.allReportsSummary && this.allReportsSummary.posOrderModel && this.allReportsSummary.posOrderModel.length > 0) {
        //     this.download(type);
        // } else {
        //     this.fetchAllReportSummaryReports(type);
        // }
        this.fetchAllReportSummaryReports(type);
    }

    /**
     * To Fetch all report summary data from service
     */
    fetchAllReportSummaryReports(type): void {
        this.isLoading = true;
        this.isAllReportsSummaryLoading = true;
        this._reportService.getPOSOrderSummaryReport(this.posLocationId, this.fromDate, this.toDate, this.pageNumber, this.pageSize, true, this.notesRequired).subscribe(response => {
            if (response) {
                this.isAllReportsSummaryLoading = false;
                this.allReportsSummary = response;
                this.isLoading = false;
                this.isResponseError = false;
                this.pageCount = response.posOrderCount;
                this.isLoadedData.emit(true);
                this.download(type);
            } else {
                this.isAllReportsSummaryLoading = false;
                this.allReportsSummary = null;
                this.setDefaultValues();
            }
        }, (error) => {
            const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
            this.allReportsSummary = null;
            this.isAllReportsSummaryLoading = false;
            this.setDefaultValues();
        });
    }

    /**
     * To download CSV or Print file from response data
     * @param  {string} type
     * @returns void
     */
    download(type: string): void {
        const allSummaryReportsLength = this.allReportsSummary && this.allReportsSummary.posOrderModel ?
            this.allReportsSummary && this.allReportsSummary.posOrderModel.length : null;
        if (allSummaryReportsLength > 0) {
            let columns = [
                this._translateService.get('reports.Date/Time')['value'],
                this._translateService.get('reports.ProcessingPeriod')['value'],
                this._translateService.get('reports.Web Order #')['value'],
                this._translateService.get('reports.Order')['value'] + ' #',
                this._translateService.get('reports.Status')['value'],
                this._translateService.get('reports.Member')['value'] + ' #',
                this._translateService.get('reports.Member Name')['value'],
                this._translateService.get('reports.User Name')['value'],
                this._translateService.get('reports.Discount')['value'],
                this._translateService.get('reports.Vat')['value'],
                this._translateService.get('reports.Handling Charge')['value'],
                this._translateService.get('reports.Total Rcvd')['value']
            ];
            let paymentHeaders = [];
            for (let method of this.paymentMethods) {
                let value = this._translateService.get('reports.' + method.paymentMethodName)['value'] ?
                    this._translateService.get('reports.' + method.paymentMethodName)['value'] : method.paymentMethodName;
                paymentHeaders.push(value)
            }
            columns = [...columns, ...paymentHeaders];
            columns.push(this._translateService.get('reports.Total')['value']);
            columns.push(this._translateService.get('reports.Notes')['value']);
            let rowdata = new Array<any>();
            let finalrows = new Array<any>();
            let paymentValues = [];
            for (let i = 0; i < allSummaryReportsLength; i++) {
                rowdata = [];
                paymentValues = [];
                let row = this.allReportsSummary.posOrderModel[i];
                let fboId = row.distributorId ? this.distributorFormatPipe.transform(row.distributorId) : '';
                rowdata.push(row.orderPostedDate ? this._datePipe.transform(row.orderPostedDate, DateConstants.DateTimeFormat) : '');
                rowdata.push(row.processingPeriod ? row.processingPeriod : '');
                rowdata.push(row.webOrderID?row.webOrderID:'');
                rowdata.push(row.orderNumber ? row.orderNumber : '');
                rowdata.push(row.orderStatus ? row.orderStatus : '');
                rowdata.push(fboId);
                rowdata.push(row.memberName ? row.memberName : '');
                rowdata.push(row.userName ? row.userName : '');
                rowdata.push(row.discountAmount?row.discountAmount:'');
                rowdata.push(row.vatAmount?row.vatAmount:'');
                rowdata.push(row.handlingCharge?row.handlingCharge:'');
                rowdata.push(row.totalAmountRcvd?row.totalAmountRcvd:'');
                for (let method of this.paymentMethods) {
                    paymentValues.push(row.paymentList && row.paymentList[method.paymentMethodKey] ? this.currenyFormatValue(row.paymentList[method.paymentMethodKey]) : '')
                }
                rowdata = [...rowdata, ...paymentValues];
                rowdata.push(row.orderTotal ? this.currenyFormatValue(row.orderTotal) : '');
                rowdata.push(row.paymentNote ? row.paymentNote : '');
                finalrows.push(rowdata);
            }
            if (this.allReportsSummary && this.allReportsSummary.paymentTotal) {
                rowdata = [];
                paymentValues = [];
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push(this._translateService.get('reports.Total')['value']);
                for (let method of this.paymentMethods) {
                    paymentValues.push(this.allReportsSummary.paymentTotal[method.paymentMethodKey] ? this.currenyFormatValue(this.allReportsSummary.paymentTotal[method.paymentMethodKey]) : '')
                }
                rowdata = [...rowdata, ...paymentValues];
                rowdata.push(this.allReportsSummary.orderTotalSum ? this.currenyFormatValue(this.allReportsSummary.orderTotalSum) : '');
                rowdata.push('');
                finalrows.push(rowdata);
            }
            const title = this._translateService.get('reports.POS Summary Reports From')['value'] + "_" + this.fromDate + this._translateService.get('reports._To_')['value'] + this.toDate;
            if (type === FileUploadConstants.CSV_FILE_EXTENSION) {
                this._customerservice.ExcelDownload(columns, finalrows, 'POS Summary Reports', '', false);
            } else if (type === FileUploadConstants.PRINT) {
                this._customerservice.constructTableAndPrint(columns, finalrows, title,true);
            }
        }
    }

    /**
     * To Get Currency Value for the price
     */
    get currenyFormatValue() {
        return (value: any) => {
            if (this.storeInfo) {
                value = this._currencyPipe.getCurrencyFormat(this.storeInfo, this.storeInfo.currencyFormatCode, value);
                return value;
            }
            return value;
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/pos-summary-reports.component.ts